module.exports = __webpack_public_path__ + "static/media/icon-1.37318301.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/icon-1.png
// module id = 2099
// module chunks = 0